/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import {Tarjeta_Caracteristica} from "../../Tarjetas/Tarjeta_Caracteristica";
import Formulario_Habitaciones_Caracteristica from "./Formulario_Habitaciones_Caracteristica";
import IngresoCheckGrupoMulti from "../../../Modulo_formularios/Componentes/IngresoCheckGrupoMulti";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Habitaciones_Detalles = ({...props}) => {
    const {IngresarObjeto} =
        useIngresarObjeto({
            props: props,
            dato: 'caracteristicas',
            nombre: 'caracteristica',
            Tarjeta: Tarjeta_Caracteristica,
            Formulario: Formulario_Habitaciones_Caracteristica
        })

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Dias de Descuento</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoDinero dato={'valorPromo'} nombre={'Valor Noche Promocion'} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoCheckGrupoMulti dato={'diasPromo'} {...props}
                                            opciones={['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo']}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Lista de Caracteristicas</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Habitaciones_Detalles